/* eslint-disable jsx-a11y/anchor-is-valid */
/* istanbul ignore file */
import {
  Toast,
  ToastBody,
  ToastTitle,
  ToastTrigger,
  useId,
} from '@fluentui/react-components';
import { useToast } from '@bingads-webui-fluent-component/toast-provider';
import { Dismiss20Regular } from '@fluentui/react-icons';
import React, { useCallback } from 'react';

const timeout = 10000;

export const useVideoNotify = ({
  i18n,
  logger,
}) => {
  const toastId = useId('video-saved-toast');
  const { dispatchToast, dismissToast } = useToast();

  const successTitle = i18n.getString(_TL_('Published successfully'));
  const successBody = i18n.getString(_TL_('Congratulations! Your video has been published to Ad Studio.'));
  const errorTitle = i18n.getString(_TL_('Export unsuccessful'));
  const errorBody = i18n.getString(_TL_('We encountered an issue while trying to export your video.'));

  const getTitle = (isSuccess: boolean) => (isSuccess ? successTitle : errorTitle);
  const getBody = (isSuccess: boolean) => (isSuccess ? successBody : errorBody);

  const notify = useCallback((isSuccess: boolean) =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Dismiss20Regular aria-label={i18n.getString(_TL_('Dismiss'))} />
            </ToastTrigger>
          }
        >{getTitle(isSuccess)}
        </ToastTitle>
        <ToastBody>
          {getBody(isSuccess)}
        </ToastBody>
      </Toast>,
      { intent: isSuccess ? 'success' : 'warning', toastId, timeout }
    ), [dispatchToast, i18n, dismissToast, toastId, logger]);

  return notify;
};
